async function deleteImage(id) {
    if ($('.image-wrapper[data-id="' + id + '"]').closest('.row').find('.image-wrapper').length > 1) {
        jQuery.ajax({
            url: growtype_child_ajax.url,
            type: 'post',
            data: {
                id: id,
                action: 'growtype_child_delete_image',
            },
            success: function (response) {
                $('.image-wrapper[data-id="' + id + '"]').parent().fadeOut().promise().done(function () {
                    $(this).remove();
                });
            }
        });
    } else {
        alert('You cannot delete the last image');
    }
}

export {deleteImage};
